import styled from 'styled-components';
import { colors } from '@ardoq/design-tokens';
import { FrontGridline } from './styles';
import {
  CROSSHAIR_LABEL_PADDING_X,
  CROSSHAIR_LINE_HEIGHT,
  CROSSHAIR_PADDING_BOTTOM,
} from './consts';
import { CrosshairXProps } from '../types';

const XCrosshair = styled(FrontGridline)`
  border-left-color: ${colors.blue600};
`;
const XCrosshairLabel = styled.label`
  position: absolute;
  padding: 0 ${CROSSHAIR_LABEL_PADDING_X}px ${CROSSHAIR_PADDING_BOTTOM}px
    ${CROSSHAIR_LABEL_PADDING_X}px;
  background-color: ${colors.blue600};
  color: white;
  line-height: ${CROSSHAIR_LINE_HEIGHT}px;
  z-index: 2;
`;

const CrosshairX = ({
  labelText,
  crosshairXPosition,
  left,
  top,
}: CrosshairXProps) => (
  <>
    <XCrosshair style={{ left: crosshairXPosition }} />
    <XCrosshairLabel
      style={{
        left,
        top,
      }}
    >
      {labelText}
    </XCrosshairLabel>
  </>
);

export { CrosshairX };
